import { INFO_COLOR_HEADER } from "../../../../Data/Bonus Ui/BasicCard";
import CommonCard from "../Common/CommonCard";

const InfoColorHeader = () => {
  return (
    <>
      {INFO_COLOR_HEADER.map((item, index) => (
        <CommonCard key={index} data={item} />
      ))}
    </>
  );
};

export default InfoColorHeader;
